import { Modal } from '@studiometa/ui';
import axios from 'axios';
import FormDl from './FormDl.js';
import Cache from '../utils/Cache.js';

const HTML = document.querySelector('html');

/**
 * Homepage class.
 */
export default class Popin extends Modal {
  /**
   * Class cofnig
   * @type {object}
   */
  static config = {
    ...Modal.config,
    name: 'Popin',
    components: {
      FormDl,
    },
  };

  /**
   * Cache instance for the Ajax requests.
   * @type {Cache}
   */
  cache = new Cache({ name: 'Popin' });

  /**
   * Prevent default behavior when clicking on the open ref and load content.
   * @param {Event} event
   * @param {number} index
   */
  onOpenClick(event, index) {
    if (event && typeof event.preventDefault === 'function') {
      event.preventDefault();
    }

    // Resolve the clicked element from currentTarget, index or first ref
    const el =
      (event && event.currentTarget) ||
      (Array.isArray(this.$refs.open) ? this.$refs.open[index ?? 0] : this.$refs.open);

    // Prefer data-href (prevents navigation) over href
    const href = el ? el.dataset.href || el.href : null;

    HTML.classList.add('show-overlay');
    this.open(href);
  }

  /**
   * Override the parent open method to dynamically set the modal's content.
   * @param {string|null} href
   */
  async open(href) {
    // Fetch content from href if provided
    if (href) {
      const content = await this.fetch(href);
      this.$refs.content.innerHTML = content;
      // Mount any newly inserted component
      this.$update();
    }
    return super.open();
  }

  /**
   * Fetch the content of the modal.
   * @param {string} url
   * @returns {string}
   */
  async fetch(url) {
    let content = this.cache.get(url);

    if (content) {
      return content;
    }

    content = await axios(url, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      params: {
        is_ajax: true,
      },
    }).then((response) => {
      const data = document.createElement('div');
      data.innerHTML = response.data;
      return data.querySelector('.content').innerHTML;
    });

    this.cache.set(url, content);

    return content;
  }

  /** */
  onFormDlSuccess() {
    this.close();
  }

  /** */
  close() {
    super.close();
    setTimeout(() => {
      HTML.classList.remove('show-overlay');
    }, 200);
  }
}
